import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import cs from "classnames";

import PillButton, { VARIANTS as PILL_VARIANTS } from "../../../../atoms/PillButton";
import Icon from "../../../../atoms/Icon";
import Tooltip from "../../../../molecules/Tooltip";
import { scrollToTop } from "../../../../../utilities/helpers";
import classes from "./Item.module.scss";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import popular from "../../../../../assets/images/most-popular-icon.png";
import { useQuery } from "../../../../../hooks";
import { StoreContext } from "../../../../../contexts";
import { APPLICATION_ROUTES } from "../../../../../constants";

const Item = ({
  cost,
  features,
  illustration,
  marked,
  title,
  url,
  gradientClass,
  titleColor,
  // canSelect,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const query = useQuery();
  const { authorization } = useContext(StoreContext);

  if (query.get("action")) {
    url += "&action=" + query.get("action");
  }

  return (
    <div
      className={cs(
        classes.container,
        isMobile ? classes.mobileContainer : "",
        { [classes.marked]: marked }
      )}
    >
      {marked && (
        <div
          className={cs(
            isMobile ? "" : classes.background,
            "br-06"
          )}
        >
          {isMobile ? (
            <MobileView>
              <div className={cs(classes.tape, classes.popularIcon, "fw-700")}>
                <img src={popular} />
              </div>
            </MobileView>
          ) : (
            <BrowserView>
              <div className={cs(classes.tape, classes.popularIcon, "fw-700")}>
                <img className={cs(classes.maxWidth130)} src={popular} />
              </div>
            </BrowserView>
          )}
        </div>
      )}

      <div className="d-flex fd-column ml-auto mr-auto">
        <div className="pos-relative">
          <div
            className={cs(classes.illustration, "d-flex jc-center ai-center")}
          >
            <img
              alt={t(title.key)}
              className={classes.image}
              src={illustration}
            />
          </div>
          <h3
            className={cs("heading-s-a ta-center", gradientClass)}
            style={{ textTransform: "uppercase", fontFamily: '"Bobby Jones", sans-serif', fontSize: "26px", lineHeight: "1.2", ...(titleColor ? { color: titleColor, WebkitTextFillColor: titleColor } : {}) }}
          >
            {t(title.key)}
          </h3>
        </div>
        <div className={cs(classes.packageFeatures, "ai-center mt-05", isMobile ? "mb-03" : "mb-06")}>
          <ul>
            {features.map((subitem, idx) => (
              <li
                key={subitem.title.key}
                className={cs(classes.packageList, "d-flex ai-center mt-03", idx < features.length - 1 && classes.packageListBorder, subitem.scrollId && classes.packageListClickable)}
                onClick={subitem.scrollId ? () => {
                  const el = document.getElementById(subitem.scrollId);
                  if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
                } : undefined}
              >
                <div className={cs("as-start mr-02", classes.featureIcon)}>
                  {subitem.img ? (
                    <img src={subitem.img} alt="" className={classes.featureIconImg} />
                  ) : (
                    <Icon name={subitem.icon} size="m" style={{ color: "#000", filter: "brightness(0)" }} />
                  )}
                </div>
                <p className={cs("m-0", subitem.classes)} style={{ color: "#000" }}>
                  {t(subitem.title.key, subitem.title.values)}
                </p>
                {subitem.tooltip.key && (
                  <div
                    className={cs(
                      classes.tooltip,
                      "ml-02 as-center"
                    )}
                  >
                    <Tooltip
                      message={
                        <Trans
                          components={{ a: <br /> }}
                          i18nKey={subitem.tooltip.key}
                          t={t}
                        />
                      }
                      icon={subitem.tooltip.icon}
                    >
                      <span className={classes.tooltipBadge}>?</span>
                    </Tooltip>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className={cs(classes.boundaryLayout, "mt-auto")}></div>
        {/* <hr className={cs(classes.boundary, "mt-auto mr-auto mb-04 ml-auto")} /> */}
        <div>
          <div
            className={cs("ta-center fd-column ai-center mt-04", classes.cakePrice)}
            style={titleColor ? { color: titleColor } : undefined}
          >
            {t("pages.birthdays.main.sections.packages.texts.5", {
              value: cost,
            })}
          </div>
          <>
            {/*{canSelect && <div className="ta-center mt-02 text-xl">Free!</div>}*/}
            <div className="d-flex fd-column ai-center mt-04">
              <PillButton
                variant={PILL_VARIANTS.YELLOW}
                onClick={() => {
                  if (authorization.user === null) {
                    history.push(`${APPLICATION_ROUTES.SIGN_IN}?redirect=${url}`);
                  } else {
                    history.push(url);
                    scrollToTop();
                  }
                }}
                style={{ justifyContent: "center", width: "100%", fontSize: "16px", padding: "10px 20px" }}
              >
                Select Package
              </PillButton>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

Item.propTypes = {
  cost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  features: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  illustration: PropTypes.string.isRequired,
  marked: PropTypes.bool.isRequired,
  gradientClass: PropTypes.string.isRequired,
  titleColor: PropTypes.string,
  title: PropTypes.shape({
    key: PropTypes.string.isRequired,
  }).isRequired,
  url: PropTypes.string.isRequired,
};

export default Item;
